import { useLocation } from 'react-router-dom';
import { NavCapability, SettingsNavItem, SettingsNavSection, settingsNav } from 'src/config/settingsNav';
import { useAuthPermissions } from 'src/hooks/useAuthPermissions';
import { useBilling } from 'src/hooks/useBilling';

export const FALLBACK_PATH = '/dashboard/selling';

type CapabilityMap = Record<NavCapability, boolean>;

export function selectSettingsSections(
  permissions: CapabilityMap,
  sections: SettingsNavSection[],
  billingEnabled = false
): SettingsNavSection[] {
  return sections
    .filter((section) => permissions[section.capability])
    .map((section) => ({ ...section, items: section.items.filter((item) => billingEnabled || !item.billingOnly) }));
}

export function resolveFirstAllowedPath(sections: SettingsNavSection[]): string {
  return sections[0]?.items[0]?.path || FALLBACK_PATH;
}

export function useSettingsNav(): {
  ready: boolean;
  sections: SettingsNavSection[];
  activeItem?: SettingsNavItem;
  firstAllowedPath: string;
} {
  const { ready, canManageOrg, canManageRestaurant, canManageRestaurantSettings } = useAuthPermissions();
  const { pathname } = useLocation();
  const { data: billing } = useBilling();

  const sections = selectSettingsSections(
    { canManageOrg, canManageRestaurant, canManageRestaurantSettings },
    settingsNav,
    billing?.enabled === true
  );
  const activeItem = sections.flatMap((section) => section.items).find((item) => item.path === pathname);

  return { ready, sections, activeItem, firstAllowedPath: resolveFirstAllowedPath(sections) };
}
